import Vue from "vue";
import Vuex from "vuex";
import request from "@/utils/axiosinit";
import { Message } from 'element-ui';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isWritingFullText: false,
    curWritingID: '',
    paragraphNum: 0,
    isCreateFirstPara: false,
    basicInfo: null,
    basicParts: [],
    confirmedBasicInfo: false,
    curLessonInfo: null,
    selfInputLesson: '',
    userID: '',
    userName: '',
    userRole: 0,
    isAdmin: false,
    userExp: '',
    userInfo: null,
    sections: [],
    userInfoExtra: {},
    userInfoReady: false,
    orderList: [],
    isOrdered: false,
    isBigModelRunning: false
  },
  getters: {

  },
  mutations: {
    changeBasicInfo(state, value) {
      state.basicInfo = value.basicInfo;
      state.basicParts = value.basicParts;
    },
    changeWritingStatus(state, status) {
      state.isWritingFullText = status;
    },
    changeWritingID(state, id) {
      state.curWritingID = id;
    },
    nextParagraph(state) {
      state.paragraphNum += 1;
    },
    beginParagraph(state) {
      state.paragraphNum = 0;
      state.isCreateFirstPara = false;
    },
    createFirstPara(state) {
      state.isCreateFirstPara = true;
    },
    runBigModel(state) {
      state.isBigModelRunning = true;
    },
    stopBigModel(state) {
      state.isBigModelRunning = false;
    },
    changeConfirmedStatus(state, status) {
      state.confirmedBasicInfo = status;
    },
    changeCurLesson(state, info) {
      state.curLessonInfo = info;
    },
    changeSelfInputLesson(state, info) {
      state.selfInputLesson = info;
    },
    changeUserInfo(state, {id, name, role, exp, isAdmin, userInfo, orderList, isOrdered}) {
      state.userID = id || '';
      state.userName = name || '';
      state.userRole = role;
      state.userExp = exp || null;
      state.isAdmin = isAdmin;
      state.userInfo = userInfo;
      state.orderList = orderList;
      state.isOrdered = isOrdered;
    },
    uiReady(state) {
      state.userInfoReady = true;
    },
    changeUserInfoExtra(state, extra) {
      state.userInfoExtra = extra;
    },
    changeSections(state, value) {
      state.sections = value;
    }
  },
  actions: {
    getSections({commit}) {
      request.get('/teachplan/common/sections').then((res) => {
        if (res && res.code === 200) {
          commit('changeSections', res.data || []);
        } else {
          console.log(res);
          Message.error('请求出错！');
        }
      }).catch((err) => {
        Vue.prototype.showErrorMsg(err);
      })
    },
    getUserInfo({commit}) {
      request.get('/teachplan/user/info').then((res) => {
        if (res && res.code === 200) {
          commit('changeUserInfo', {
            id: res.data.id,
            name: res.data.userName,
            role: res.data.role || 0,
            isAdmin: res.data.role === 1,
            exp: res.data.experience || null,
            userInfo: res.data,
            orderList: res.data.userOrderList || [],
            isOrdered: (res.data.userOrderList || []).length > 0
          })
        } else {
          console.log(res);
          Message.error('请求出错！');
        }
      }).catch((err) => {
        Vue.prototype.showErrorMsg(err);
      }).finally(() => {
        commit('uiReady');
      })
    },
    getUserInfoExtra({commit}, confirmInfo) {
      return request.get('/teachplan/user/extendedInfo').then((res) => {
        if (res && res.code === 200) {
          let data = res.data || {};
          commit('changeUserInfoExtra', data);
          if (confirmInfo === true) {
            // return !!(data.bookId && data.gradeId && data.sectionId && data.subjectId && data.textBookVersionId);
            return !!(data.gradeId && data.sectionId && data.subjectId);
          }
        } else {
          console.log(res);
          Message.error('请求出错！');
        }
      }).catch((err) => {
        Vue.prototype.showErrorMsg(err);
      })
    }
  }
});

export default store;
